import { Link, useSearchParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import customHeaders, { getSpace } from '../../common/headers';
import { ButtonBasic, TableBox, NoDataContent, DropDownSelector } from '@lk-gtcom/ecomlab-components';
import { ReactComponent as Info } from './img/info.svg';
import { OlegHttps } from '../../fetchUrls';
import { useRef } from 'react';
import { useDataTable } from '../../common/hooks';
import useGeneralStore from '../../store/general';
import { SceletonCardRecommendation } from './SceletonCardRecommendation/SceletonCardRecommendation';
import { fetchApiFilterVer3 } from '../../common/filtersFunc';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { RequestController } from '../../common/filtersFunc';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { useResponseHandler } from '../../common/auth';
import './Hint.scss';


const statusCriticality = (status) => {
  const criticality = {
    'Средне критично': 'orange',
    'Критично': 'red',
    'Не критично': 'green',
  };

  return (
    <div
      className={`card-recommendation__status-criticality ${`status-${criticality?.[status]}`}`}
    >
      <Info />
      {status}
    </div>
  );
};

const CardRecommendation = (props) => {
  const {
    api_count,
    problem_category,
    importance,
    problem_name,
    problem_solution,
    value,
    category,
    setCategory,
  } = props;

  return (
    <div
      className="card-recommendation"
      key={problem_category + problem_solution}
    >
      <header className="card-recommendation__header">
        <div className="card-recommendation__info-panel">
          {statusCriticality(importance)}
        </div>
        <h3 className="card-recommendation__title">{problem_category}</h3>
      </header>

      <div className="card-recommendation__content">
        <div className="card-recommendation__reason">
          <h6 className="card-recommendation__title-reason">Причина</h6>
          <p className="card-recommendation__text">{problem_name}</p>
        </div>

        {problem_solution && (
          <div className="card-recommendation__solution">
            <h6 className="card-recommendation__title-solution">Решение</h6>
            <p className="card-recommendation__text">{problem_solution}</p>
          </div>
        )}

        {api_count && (
          <p className="card-recommendation__text">
            Магазины с проблемой: {api_count}
          </p>
        )}
        {value && <p className="card-recommendation__text">{value}</p>}
      </div>

      {problem_solution && (
        <ButtonBasic
          green
          width="100%"
          text="Решить проблему"
          style={{
            marginTop: 'auto',
          }}
          onClick={(e) => setCategory(category)}
        />
      )}
    </div>
  );
};

const Hint = () => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  const requestControllerRef = useRef(new RequestController());

  const [loading, setLoading] = useState(false);
  const [loadingCard, setLoadingCard] = useState(false);
  const [cards, setCards] = useState([]);
  const [category, setCategory] = useState('');

  const [isRequestCard, setIsRequestCard] = useState(false)

  // Фильтр
  const filterConfig = [
    { key: 'api', type: 'multi' }
  ];

  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);

  const [totalApi, setTotalApi] = useState(0);

  const [apiPage, setApiPage] = useState(1);
  const [apiQuery, setApiQuery] = useState('');
  const [apiData, setApiData] = useState([]);

  const tabs = [
    { label: 'Проблемы', value: 'problems' },
    { label: 'Решения', value: 'table' },
  ];
  const [searchParams, setSearchParams] = useSearchParams();

  const initialTab = searchParams.get('tab') || tabs[0].value;
  const [pageValue, setPageValue] = useState(initialTab);

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );

  const { setFetchedData, setHeaders, setSort } = setTableFuncs;

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  useEffect(() => {
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.api) setSelectedApi(urlParams.api)

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
          setIsRequestCard(prev => !prev)
        }
      }, 10);
    }
  }, [urlParams]);

  useEffect(() => {
    updateURL({
      api: urlParams?.api || selectedApi,
    })
  }, []);



  const apiFilter = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalApi,
      page: apiPage,
      set: setApiData,
      setApiData: setApiData,
      searchParam: apiQuery,
      selectedApi,
      filter: 'api_id'
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  };

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    apiFilter();
  }, [isFilterRequest, apiPage, apiQuery])

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);

  const resetTable = () => {
    // paginatorRef.current.reset();
    // paginatorRef.current.setTotal(0);
    setSort({});
    setHeaders([]);
    setFetchedData([]);
  };

  const fetchHints = (abortController = new AbortController()) => {
    setLoadingCard(true);
    const url = `${OlegHttps}/api/v1/hints/cards`;

    const body = JSON.stringify({
      api_id_list: getValueMultiFilter(selectedApi),
    });

    fetch(url, { method: 'POST', headers, body, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setCards(json))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return;
        setLoadingCard(false);
      });
  };

  const fetchTableData = (params, abortController = new AbortController()) => {
    if (!category) return
    let sort;
    let filtersParam;

    if (params) {
      [sort, filtersParam] = params;
    }

    setLoading(true);
    let url = `${OlegHttps}/api/v1/hints/table/${category}${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''
      }`;

    const body = JSON.stringify({
      api_id_list: getValueMultiFilter(selectedApi),
      limit: paginatorRef?.current?.limit ? paginatorRef?.current?.limit : 10,
      page: paginatorRef?.current?.page ? paginatorRef?.current?.page : 1,
      filters: filtersParam,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => {
        if (abortController.signal.aborted) return;
        setLoading(false);
      });
  };

  useEffect(() => {
    const abortController = new AbortController();
    fetchHints(abortController);
    return () => abortController.abort();
  }, [isRequestCard]);

  useEffect(() => {
    const abortController = new AbortController();
    fetchTableData([], abortController);
    return () => abortController.abort();
  }, [category, isTableRequest]);

  useEffect(() => {
    const tabFromUrl = searchParams.get('tab') || tabs[0].value;
    setPageValue(tabFromUrl);

    if (tabFromUrl === 'problems') {
      resetTable();
      setCategory('');
    }
  }, [searchParams]);

  const handleCategorySelect = (category) => {
    setCategory(category);
    setSearchParams({ tab: 'table', category: category });
  };

  useEffect(() => {
    const tab = searchParams.get('tab') || 'problems';
    const urlCategory = searchParams.get('category') || '';
    setPageValue(tab);

    if (tab === 'table' && urlCategory) {
      setCategory(urlCategory);
    } else if (tab === 'problems') {
      setCategory('');
    }
  }, [searchParams]);

  return (
    <div className="hint-page">
      <h1 className="hint-page__title">Рекомендации</h1>

      <DropDownSelector
        options_prop={apiData}
        state={selectedApi}
        total={totalApi}
        setState={setSelectedApi}
        placeholder="Магазин"
        fetchCallback={setApiPage}
        setInputChange={setApiQuery}
        inputRef={true}
        multi
        onBlur={() => {
          updateURL({ api: selectedApi });
          setIsRequestCard(!isRequestCard)
        }}
      />

      <nav className="breadcrumbs">
        <ul>
          <li>
            <Link
              to={`?tab=problems`}
              onClick={() => setSearchParams({ tab: 'problems' })}
              className={pageValue === 'problems' ? 'active' : ''}
            >
              Рекомендации
            </Link>
          </li>
          {pageValue === 'table' && (
            <>
              <span className="breadcrumb-divider">/</span>
              <li>
                <Link
                  to={`?tab=table&category=${category}`}
                  onClick={() => setSearchParams({ tab: 'table', category })}
                  className={pageValue === 'table' ? 'active' : ''}
                >
                  Решение
                </Link>
              </li>
            </>
          )}
        </ul>
      </nav>
      <>
        {pageValue === 'problems' ? (
          <div className="hint-page__card-content">
            {loadingCard ? (
              [...Array(12)].map((el) => {
                return <SceletonCardRecommendation />
              })

              // <MoonLoader color="#7b7b7b" speedMultiplier={0.5} />
            ) : (
              cards.length ?
                cards?.map((props, ind) => {
                  return (
                    <CardRecommendation
                      {...props}
                      key={ind}
                      setCategory={(e) => {
                        setCategory(e);
                        handleCategorySelect(e);
                      }}
                    />
                  );
                })
                :
                <NoDataContent
                  title="Рекомендации отсутсвуют"
                />
            )}
          </div>
        ) : (
          <TableBox
            {...tableProps}
            ref={paginatorRef}
            loading={loading}
            paginator={true}
            fetchCallback={() => fetchTableData()}
            sortingFunc={() => fetchTableData()}
          />
        )}
      </>
    </div>
  );
};

export { Hint };
